<template>
  <span
    v-if="typeof contactRequest.unsubscribeRequestId === 'string'"
    class="inline-flex items-center rounded-full bg-red-100 px-3 py-0.5 text-sm font-medium text-red-800"
    >{{ $t('global.unsubscribed') }}</span
  >
  <BaseButton v-else primary outline @click="showUnsubscribeDialog"> Unsubscribe </BaseButton>
</template>

<script>
export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showUnsubscribeDialog() {
      this.$modal.show({
        component: () => import('./UnsubscribeDialog.vue'),
        props: {
          contactRequest: this.contactRequest,
        },
        on: {
          'contact-request:unsubscribed': () => {
            this.$router.replace({
              name: this.$route.name,
              params: {
                ...this.$route.params,
              },
              query: {
                ...this.$route.query,
                updated: new Date().getTime(),
              },
            });
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
